import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { IEditableProps } from 'components/uiKit/Editable'
import Editable from 'components/uiKit/Editable'

const FieldEditable = ({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<IEditableProps, string | null>) => {
  const handleChange = useCallback(
    (value: string | null) => onChange({ name, value }),
    [name, onChange],
  )

  return <Editable {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldEditable) as typeof FieldEditable
